/* global axios */
// Aceleres: API para acoes em mensagens individuais (reacoes, pin, destaque)
// Endpoints: POST /api/v1/accounts/:accountId/aceleres/messages/:id/react|pin|star

const buildUrl = (accountId, messageId, action) =>
  `/api/v1/accounts/${accountId}/aceleres/messages/${messageId}/${action}`;

export default {
  starred(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/aceleres/starred_messages`
    );
  },
  react(accountId, messageId, emoji) {
    return axios.post(buildUrl(accountId, messageId, 'react'), { emoji });
  },
  // `duration` e o periodo escolhido no modal ('24h' | '7d' | '30d'); ao
  // desafixar nao vai nada, porque o endpoint alterna.
  pin(accountId, messageId, duration) {
    return axios.post(buildUrl(accountId, messageId, 'pin'), { duration });
  },
  star(accountId, messageId) {
    return axios.post(buildUrl(accountId, messageId, 'star'));
  },
};
